<template>
  <v-row>
    <v-col>
      <p>
        この画面が表示される場合は再度浸水アラートマップログインURLからログインし直してください。
      </p>
      <h4>
        LINEトーク画面のメニューに浸水アラートマップのリンクがある場合
      </h4>
      <p class="body-2">
        メニュー内の浸水アラートマップのリンクから入り直してください。
      </p>
      <h4>
        LINEトーク画面のメニューに浸水アラートマップのリンクがない場合
      </h4>
      <p class="body-2">
        LINEアプリのkeep機能で浸水アラートマップのリンクをkeepされている場合は、keep画面から浸水アラートマップに入り直してください。
      </p>
    </v-col>
  </v-row>
</template>

<script>
import { Auth, I18n } from 'aws-amplify'

export default {
  name: 'AuthSignIn'
}
</script>
